<template>
    <el-container>
        <div class="container">
            <div class="searchBox">
                <el-form :inline="true">
                    <el-row>
                        <el-col :span="24" class="leftAlignTtem">
                            <el-form-item label="上传发票文件">
                                <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadUrl"
                                    :headers="headerObj"
                                     accept=".xls,.xlsx"
                                     >
                                        <el-button  type="success" round size="small">点击上传</el-button>
                                    </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24" class="leftAlignTtem">
                          <el-form-item label="申请开票日期">
                            <el-date-picker
                              v-model="requestInvocieDate"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                            </el-date-picker>
                            <el-button  type="primary" round size="small" @click="handleInvoiceExport">点击导出开票请求</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24" class="leftAlignTtem">
                        <el-link type="primary" href="http://hr.platform-cn.com:8001/1YS.ASP?T1=&T7=&sd=&ed=&sd1=&ed1=&sd2=&ed2=&employee_no=p0040&t2=&T3=&T4=&Y1=&Y2=&T33=&T34=" target="_blank" >收款和发票入口</el-link>
                      </el-col>
                    </el-row>
                 </el-form>
             </div>
         </div>
    </el-container>
</template>

<script>

export default {
  name: 'contracts',
  data () {
    return {
      uploadUrl: process.env.API_URL + 'workMfg/invoice/uploadInvoice',
      exportUrl: process.env.API_URL + 'workMfg/invoice/exportInvoice',
      headerObj: {
        'auth-token': ''
      },
      requestInvocieDate: []
    }
  },
  methods: {
    handleInvoiceExport () {
      if (this.requestInvocieDate.length !== 2) {
        this.$message.info('请选择申请开票日期')
      } else {
        const exportUrl = this.exportUrl + '?requestTimeBegin=' + formatDate(this.requestInvocieDate[0]) + '&requestTimeEnd=' + formatDate(this.requestInvocieDate[1]) + '&auth_token=' + this.headerObj['auth-token']
        window.open(exportUrl)
      }
    }
  },
  mounted () {
    this.headerObj['auth-token'] = localStorage.getItem('auth-token')
  }
}

function formatDate (date) {
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  return `${year}-${month}-${day}`
}

</script>

<style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:70% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 70%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

</style>



// WEBPACK FOOTER //
// src/page/subPage/InvoiceUpload.vue